<template>
    <b-card
        class="text-center my-2"
        border-variant="info"
        bg-variant="primary"
        text-variant="white"
    >
        <div slot="header">
            <span class="figure-title">{{ title }}</span>
        </div>
        <p class="card-text figure-value">
            <slot></slot>
        </p>
    </b-card>
</template>
<script>
export default {
    props: ['title', 'status'],
    methods: {},
}
</script>
<style scoped>
.figure-value {
    font-size: 2rem;
    font-weight: bold;
}
.figure-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: rgb(3, 29, 80);
}
</style>
